import { Textfield } from '@src/shared/fields/text-field';
import { ErrorMessage } from 'formik';
import { Label } from '@src/design-system/label';
import { User } from 'iconsax-react';
import { CustomErrorMessage } from '@src/design-system/error-message';
import { PhoneNumberInput } from '@src/design-system/phone-number-input';
import type { TUniversityPayload } from '@src/features/universities/services/universities-api';
import { useFormikContext } from 'formik';

const UniversityContactInformation = () => {
  const { values, setFieldValue } = useFormikContext<TUniversityPayload>();

  return (
    <div className='space-y-4 border border-gray-200 rounded-[12px] p-4'>
      <div className='flex items-center gap-2'>
        <User
          className='text-gray-900'
          size={24}
        />
        <p className='text-gray-900 font-medium'>Contact Information</p>
      </div>
      <div className='grid grid-cols-2 gap-4'>
        <div className='col-span-2'>
          <Textfield
            name='main_contact_name'
            label='Contact Name'
            placeholder='Enter Contact Name'
          />
        </div>
        <Textfield
          name='main_contact_email'
          label='Email'
          placeholder='Enter Email'
        />
        <div>
          <Label>Phone Number</Label>
          <PhoneNumberInput
            name='main_contact_phone'
            placeholder='ex: +20124356762'
            onChange={(value) => setFieldValue('main_contact_phone', value)}
            value={values.main_contact_phone}
          />
          <ErrorMessage
            name='main_contact_phone'
            component={CustomErrorMessage}
          />
        </div>
      </div>
    </div>
  );
};

export default UniversityContactInformation;
